import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

type Props = {
  updateId: number
  value: string
  placeholder: string
  updateValue: (v: string) => void
  width: number
}

const TextBox = (props: Props) => {
  const [value, setValue] = useState(props.value)
  const [showInput, setShowInput] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const [focusInput, setFocusInput] = useState(false)
  const [initialValue, setInitialValue] = useState('')

  useEffect(() => {
    setShowInput(false)
    setInitialValue(props.value)
  }, [props.updateId])

  useEffect(() => {
    setValue(props.value)
  }, [props.value])

  const handleChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = event

    setValue(value)
  }

  const handleClickApply = () => {
    setShowInput(false)

    setInitialValue(value)
    props.updateValue(value)
  }
  const handleClickCancel = () => {
    setValue(initialValue)
    setShowInput(false)
  }

  const handleClickBox = () => {
    setShowInput(true)
    setFocusInput(true)
  }

  const handleKeydown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') handleClickApply()
  }

  useEffect(() => {
    if (focusInput) {
      inputRef.current?.focus()
      setFocusInput(false)
    }
  }, [focusInput])

  const handleBlurTextArea = () => {
    handleClickCancel()
  }

  return (
    <Container>
      {showInput ? (
        <>
          <input
            style={{
              width: `${props.width}px`,
            }}
            ref={inputRef}
            onKeyDown={handleKeydown}
            onChange={handleChangeInput}
            onBlur={handleBlurTextArea}
            placeholder={props.placeholder}
            value={value}
          />
        </>
      ) : (
        <Box onClick={handleClickBox}>
          {value === '' ? <span>{props.placeholder}</span> : value}
        </Box>
      )}
    </Container>
  )
}

const Container = styled.div`
  input {
    padding: 10px 10px;
    box-sizing: border-box;
    border: 1px solid #eee;
    margin-bottom: 6px;
    font-size: 0.9rem;
  }
  button {
    padding: 10px 30px;
    border: none;
    background-color: orange;
    margin-right: 10px;
  }
  button:nth-child(3) {
    background-color: #dadada;
  }
`
const Box = styled.div`
  font-size: 1rem;
  //white-space: pre-wrap;
  line-height: 1.6;
  padding: 6px 10px;
  border: 1px solid #ddd;

  span {
    color: #ddd;
  }
`

export default TextBox
